import { Badge as AntBadge } from "antd";
import type { BadgeProps as AntBadgeProps } from "antd";

export type BadgeProps = AntBadgeProps;

export const CommonBadge = (props: BadgeProps) => {
  return <AntBadge {...props} />;
};
